import { render, staticRenderFns } from "./MessageTag.vue?vue&type=template&id=6fccf5d0&scoped=true&"
import script from "./MessageTag.vue?vue&type=script&lang=js&"
export * from "./MessageTag.vue?vue&type=script&lang=js&"
import style0 from "./MessageTag.vue?vue&type=style&index=0&id=6fccf5d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fccf5d0",
  null
  
)

export default component.exports